"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var table_style_1 = require("../../components/table/table.style");
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-Accounts',
    tableCell: 'c-Accounts__TableCell',
    tableCellFaint: 'c-Accounts__TableCell--faint',
    tableCellUppercase: 'c-Accounts__TableCell--uppercase',
    tableCellGhost: 'c-Accounts__TableCell--ghost',
    tableCellRoleActions: 'c-Accounts__TableCellRole',
    changeRole: 'c-Accounts__ChangeRole'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = (_b = {},
        _b["& .".concat(table_style_1.CSS.container)] = {
            width: '80%',
            'margin-bottom': theme_1.DefaultTheme.space(6)
        },
        _b["& .".concat(table_style_1.CSS.cell, ":nth-last-of-type(2)")] = {
            overflow: 'visible'
        },
        _b),
    _a[exports.CSS.tableCellFaint] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[exports.CSS.tableCellUppercase] = {
        'text-transform': 'uppercase'
    },
    _a["".concat(table_style_1.CSS.row, ":hover .").concat(exports.CSS.tableCellGhost)] = {
        visibility: 'visible'
    },
    _a[exports.CSS.tableCellGhost] = {
        visibility: 'hidden'
    },
    _a[exports.CSS.tableCellRoleActions] = {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'flex-end',
        '& .mdl-button': {
            'font-size': 'inherit'
        }
    },
    _a);
//# sourceMappingURL=accounts.style.js.map